import InfoTab from '@/views/admin/home/InfoTab.vue';
import TeamsTab from '@/views/admin/home/TeamTab.vue';
import ContestTab from '@/views/admin/home/ContestTab.vue';
import TermsTurnIn from '@/views/admin/home/TermsTurnIn.vue';
import TeamOrder from '@/views/admin/home/TeamOrder.vue';
import TeamSubmissions from '@/views/admin/home/TeamSubmissions.vue';
import TeamScreeningOrderFriday from '@/views/admin/home/TeamScreeningOrderFriday.vue';
import TeamScreeningOrderSaturday from '@/views/admin/home/TeamScreeningOrderSaturday.vue';
export const adminHomeRoutes = [
  {
    path: '/admin/home/info',
    name: 'Admin',
    component: InfoTab,
    meta: { guest: false, section: 'info' },
  },
  {
    path: '/admin/home/teams',
    name: 'AdminHomeTeams',
    component: TeamsTab,
    meta: { guest: false, section: 'teams' },
  },
  {
    path: '/admin/home/contest',
    name: 'AdminHomeContest',
    component: ContestTab,
    meta: { guest: false, section: 'contest' },
  },
  {
    path: '/admin/home/terms',
    name: 'AdminTermsTurnIn',
    component: TermsTurnIn,
    meta: { guest: false, section: 'terms' },
  },
  {
    path: '/admin/home/order',
    name: 'AdminTeamOrder',
    component: TeamOrder,
    meta: { guest: false, section: 'info' },
  },
  {
    path: '/admin/home/submissions',
    name: 'AdminTeamSubmissions',
    component: TeamSubmissions,
    meta: { guest: false, section: 'info' },
  },
  {
    path: '/admin/home/friday',
    name: 'AdminFridayScreeningOrder',
    component: TeamScreeningOrderFriday,
    meta: { guest: false },
  },
  {
    path: '/admin/home/saturday',
    name: 'AdminSaturdayScreeningOrder',
    component: TeamScreeningOrderSaturday,
    meta: { guest: false },
  },
];
